<template>
  <div class="accueil">
    <v-container>
      En construction. Soyez patient-e-s
    </v-container>
  </div>
</template>

<script>
import { storage, Storage } from "@/storage";
import store from "@/store";
import EventBus from "@/eventBus";
export default {
  created: function() {
  },
  mounted:function() {
  },
  computed: {},
  props: {},
  data() {
    return {
    } 
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
